import SelectAutocomplete from "common/SelectAutocomplete";
import { SelectWrapper } from "common/BqnSelector";
import React, { useContext } from "react";
import BqnContext from "common/BqnContext";
import styled from "styled-components";

export const bqnInstanceAsOption = ({ bqnId, hostname }) => ({
  value: Number(bqnId),
  label: `BQN ${bqnId}` + (!hostname ? "" : `: ${hostname}`),
});

const TitleAndSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0px 35px 0px;
`;

const SelectTitle = styled.div`
  margin-right: 20px;
  font-family: "AllianceNo2-SemiBold" !important;
  font-size: 13px;
`;

const doesNothing = () => {};

const optionOfValue = selected =>
  ({ value }) => String(value) === String(selected);

export const getSelectedBqn = (bqnId, loginBqnId) =>
  (bqnId !== "all") ? bqnId : loginBqnId;

const ChooseInstance = ({
  action = "shutdown",
  title = "Select BQN",
  selected,
  setSelected = doesNothing,
  includeAll = false,
}) => {
  const { bqns, loginBqnId } = useContext(BqnContext);
  const options = [
    ...(includeAll === true ? [{ value: "all", label: "All" }] : []),
    ...(bqns !== undefined ? bqns.map(bqnInstanceAsOption) : []),
  ];
  const selectedOption = options.find(optionOfValue(selected)) ||
    options.find(optionOfValue(loginBqnId));
  return (
    <TitleAndSelectWrapper>
      <SelectTitle>{title}</SelectTitle>
      <SelectWrapper>
        <SelectAutocomplete
          className={`${action}-select`}
          title={`${action}-select`}
          name={action}
          selected={selectedOption}
          onChange={(value) => {
            setSelected(value);
          }}
          options={options}
        />
      </SelectWrapper>
    </TitleAndSelectWrapper>
  );
};

export default ChooseInstance;
